module.exports = __webpack_public_path__ + "img/sina.f61a7043.png";